import { render, staticRenderFns } from "./FiltroPessoaFisica.vue?vue&type=template&id=e6fdf252"
import script from "./FiltroPessoaFisica.vue?vue&type=script&lang=js"
export * from "./FiltroPessoaFisica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports